export const packagingLayerTypesData = [
    {
        "layerType": "adhesive",
        "layerName": "Adhesive",
        "layerDescriptionIds": [1, 2, 3, 4, 5, 6, 7, 43]
    },
    {
        "layerType": "ceramics",
        "layerName": "Ceramics",
        "layerDescriptionIds": []
    },
    {
        "layerType": "coating",
        "layerName": "Coating",
        "layerDescriptionIds": [8, 9, 5, 10, 11, 12, 43]
    },
    {
        "layerType": "compound",
        "layerName": "Compound",
        "layerDescriptionIds": [13, 43]
    },
    {
        "layerType": "glass",
        "layerName": "Glass",
        "layerDescriptionIds": [14, 15]
    },
    {
        "layerType": "ink",
        "layerName": "Ink",
        "layerDescriptionIds": [10, 16, 5, 12, 43]
    },
    {
        "layerType": "melamine",
        "layerName": "Melamine",
        "layerDescriptionIds": []
    },
    {
        "layerType": "metal",
        "layerName": "Metal",
        "layerDescriptionIds": [17, 18, 19, 20, 43]
    },
    {
        "layerType": "paper",
        "layerName": "Paper",
        "layerDescriptionIds": [22, 21]
    },
    {
        "layerType": "paperboard",
        "layerName": "Paperboard",
        "layerDescriptionIds": [22, 21]
    },
    {
        "layerType": "plastic",
        "layerName": "Plastic",
        "layerDescriptionIds": [13, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 43]
    },
    {
        "layerType": "rubber",
        "layerName": "Rubber",
        "layerDescriptionIds": []
    },
    {
        "layerType": "silicone",
        "layerName": "Silicone",
        "layerDescriptionIds": []
    },
    {
        "layerType": "wood",
        "layerName": "Wood",
        "layerDescriptionIds": [41, 42, 43]
    },
    {
        "layerType": "other",
        "layerName": "Other",
        "layerDescriptionIds": []
    },
    {
        "layerType": "overLacquer",
        "layerName": "Over Lacquer",
        "layerDescriptionIds": [10, 16, 5, 12, 43]
    },
    {
        "layerType": "aluminumFoil",
        "layerName": "Foil (Aluminum Foil)",
        "layerDescriptionIds": []
    }
];

export const packagingLayerDescriptionsData = [
    {
        "id": 1,
        "descriptionType": "coldsealLatexBased",
        "descriptionName": "Coldseal - Latex Based"
    },
    {
        "id": 2,
        "descriptionType": "dispersionWaterBased",
        "descriptionName": "Dispersion/Water Based"
    },
    {
        "id": 3,
        "descriptionType": "hotMelt",
        "descriptionName": "Hot Melt"
    },
    {
        "id": 4,
        "descriptionType": "polyurethane",
        "descriptionName": "Polyurethane"
    },
    {
        "id": 5,
        "descriptionType": "solventBased",
        "descriptionName": "Solvent Based"
    },
    {
        "id": 6,
        "descriptionType": "starchBased",
        "descriptionName": "Starch Based"
    },
    {
        "id": 7,
        "descriptionType": "waxParaffinBased",
        "descriptionName": "Wax/Paraffin Based"
    },
    {
        "id": 8,
        "descriptionType": "epoxyPhenolicBased",
        "descriptionName": "Epoxy Phenolic Based"
    },
    {
        "id": 9,
        "descriptionType": "phenolicMelamineFormaldehyde",
        "descriptionName": "Phenolic - Melamine Formaldehyde"
    },
    {
        "id": 10,
        "descriptionType": "uVEB",
        "descriptionName": "UV/EB"
    },
    {
        "id": 11,
        "descriptionType": "vinylicOrganasol",
        "descriptionName": "Vinylic Organasol"
    },
    {
        "id": 12,
        "descriptionType": "waterBased",
        "descriptionName": "Water Based"
    },
    {
        "id": 13,
        "descriptionType": "pVC",
        "descriptionName": "PVC"
    },
    {
        "id": 14,
        "descriptionType": "clear",
        "descriptionName": "Clear"
    },
    {
        "id": 15,
        "descriptionType": "coloured",
        "descriptionName": "Coloured"
    },
    {
        "id": 16,
        "descriptionType": "digital",
        "descriptionName": "Digital"
    },
    {
        "id": 17,
        "descriptionType": "aluminum",
        "descriptionName": "Aluminum"
    },
    {
        "id": 18,
        "descriptionType": "steel",
        "descriptionName": "Steel"
    },
    {
        "id": 19,
        "descriptionType": "steelTinPlate",
        "descriptionName": "Steel Tin Plate"
    },
    {
        "id": 20,
        "descriptionType": "tin",
        "descriptionName": "Tin"
    },
    {
        "id": 21,
        "descriptionType": "recycled",
        "descriptionName": "Recycled"
    },
    {
        "id": 22,
        "descriptionType": "virgin",
        "descriptionName": "Virgin"
    },
    {
        "id": 23,
        "descriptionType": "aBS",
        "descriptionName": "ABS"
    },
    {
        "id": 24,
        "descriptionType": "biofilm",
        "descriptionName": "Biofilm"
    },
    {
        "id": 25,
        "descriptionType": "colourant",
        "descriptionName": "Colourant"
    },
    {
        "id": 26,
        "descriptionType": "eVOH",
        "descriptionName": "EVOH"
    },
    {
        "id": 27,
        "descriptionType": "hDPE",
        "descriptionName": "HDPE"
    },
    {
        "id": 28,
        "descriptionType": "lDPE",
        "descriptionName": "LDPE"
    },
    {
        "id": 29,
        "descriptionType": "metOPP",
        "descriptionName": "Met OPP"
    },
    {
        "id": 30,
        "descriptionType": "metPE",
        "descriptionName": "Met PE"
    },
    {
        "id": 31,
        "descriptionType": "metPET",
        "descriptionName": "Met PET"
    },
    {
        "id": 32,
        "descriptionType": "oPP",
        "descriptionName": "OPP"
    },
    {
        "id": 33,
        "descriptionType": "pA",
        "descriptionName": "PA"
    },
    {
        "id": 34,
        "descriptionType": "pC",
        "descriptionName": "PC"
    },
    {
        "id": 35,
        "descriptionType": "pE",
        "descriptionName": "PE"
    },
    {
        "id": 36,
        "descriptionType": "pET",
        "descriptionName": "PET"
    },
    {
        "id": 37,
        "descriptionType": "pLA",
        "descriptionName": "PLA"
    },
    {
        "id": 38,
        "descriptionType": "pP",
        "descriptionName": "PP"
    },
    {
        "id": 39,
        "descriptionType": "pS",
        "descriptionName": "PS"
    },
    {
        "id": 40,
        "descriptionType": "tPE",
        "descriptionName": "TPE"
    },
    {
        "id": 41,
        "descriptionType": "beech",
        "descriptionName": "Beech"
    },
    {
        "id": 42,
        "descriptionType": "birch",
        "descriptionName": "Birch"
    },
    {
        "id": 43,
        "descriptionType": "other",
        "descriptionName": "Other"
    }
];